// @flow
import * as React from 'react';
import type { TPlayersById } from '../../modules/types';
import {
	TradeInCell,
	TradeOutCell,
	TransactionPlayers,
	TransactionPlayersWrapper,
	ButtonPrimary,
	ButtonSecondary,
	ApprovalSpan
} from '../';
import { TransactionButtonsWrapper } from './TransactionButtonsWrapper';

type Props = {
	players_by_id: TPlayersById,
	user_id: number,
	trade: Object,
	blockTrade: Function,
	approveTrade: Function
}
export const TradeProposed = ({
	trade, players_by_id, blockTrade, approveTrade, user_id }: Props) => {
	const {
		id: trade_id, 
		new_player_id, 
		old_player_id, 
		new_team_name, 
		old_team_name,
		 status, 
		 votes, 
		 approve_trade,
	} = trade;
	const pendingCopyText = () => {
		if(approve_trade === "league"){
			return "Pending League Approval";
		}
		if(approve_trade === "commissioner"){
			return "Waiting Commissioner Approval";
		
		}
		return "";
	};
	const yes_vote = votes.yes.includes(user_id);
	const no_vote = votes.no.includes(user_id);
	return (
		<TransactionPlayersWrapper>
			<TransactionPlayers>
				<p>
					{new_team_name} has offered:
				</p>
				{new_player_id.map(id => (<TradeInCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
			{status === 'accepted' || yes_vote || no_vote ?
				<TransactionButtonsWrapper>
					 <ApprovalSpan>{pendingCopyText()}</ApprovalSpan>
				</TransactionButtonsWrapper> : (
					<TransactionButtonsWrapper>
						<ButtonPrimary onClick={() => approveTrade({ trade_id })}>
							APPROVE TRADE
						</ButtonPrimary>
						<ButtonSecondary onClick={() => blockTrade({ trade_id })}>
							REJECT TRADE
						</ButtonSecondary>
					</TransactionButtonsWrapper>
				)}
			<TransactionPlayers>
				<p>
					To {old_team_name}, for:
				</p>
				{old_player_id.map(id => (<TradeOutCell key={id} player={players_by_id[id]} />))}
			</TransactionPlayers>
		</TransactionPlayersWrapper>
	);
};

export default TradeProposed;


// WEBPACK FOOTER //
// ./src/components/Trades/TradeProposed.js